import React, { Component } from 'react';
import Button from '../button/Button';
export default class SecondaryButton extends Component {
	render() {
		return (
			<Button bg="white" color="darkblue" {...this.props} border>
			{this.props.children}
			</Button>
		);
	}
}
